import {PriceRuleEntity} from "src/app/features/financial/price_rules/entities";

export class PriceRulesTranslationKeys {
	setKeys(priceRules: any[], isConcretePrice: boolean=true) {
		for(let pr=0; pr<priceRules.length; pr++) {
			priceRules[pr].translationKey='';
			switch(priceRules[pr].entity) {
				case PriceRuleEntity.project:
					priceRules[pr].translationKey='entity.project';
					break;
				case PriceRuleEntity.baseprice:
					priceRules[pr].translationKey='financial.baseprice';
					break;
				case PriceRuleEntity.customer:
					priceRules[pr].translationKey='entity.customer';
					break;
				case PriceRuleEntity.pricelist:
					if(isConcretePrice)
						priceRules[pr].translationKey='financial.concrete-pricelist';
					else
						priceRules[pr].translationKey='financial.article-pricelist';
					break;
				case PriceRuleEntity.plant:
					priceRules[pr].translationKey='company.plant';
					break;
				case PriceRuleEntity.company:
					priceRules[pr].translationKey='company';
					break;
			}
		}
		return priceRules;
	}
}
